import React from 'react';

type Props = {
  children: React.ReactNode;
};

function CardContent({ children }: Props) {
  const classes = ['px-4', 'py-5', 'sm:p-6'];
  return <div className={classes.join(' ')}>{children}</div>;
}

export default CardContent;
